/* ==========================================================================
   AURUM — "already inside" hero + arrival rooms.
   Both vaults are already open. Center slab anchors. LEFT = SHOP, RIGHT = SELL.
   On choosing a side, the destination clip plays then FREEZES on its final
   frame (no loop). No door swing, no wheel spin, no hallway.

   SELL: the office clip settles, then THE ACQUISITION ROOM (#acqRoom) rises.
   SHOP: the gallery clip settles, then THE SHOWROOM (#showRoom) rises.
   Both rooms are authored inline in home-v2.html and share one engine here.
   The visitor is already inside; the rooms never reload.
   Replaces the GENESIS journey player. Does NOT depend on the descent.
   ========================================================================== */
(function () {
  var ROOMS = {
    shop: {
      clip: (window.MBM_CLIP_SHOP || ''),
      room: 'showRoom', rv: '.sr-rv', hero: '.sr-lead .sr-rv'
    },
    sell: {
      clip: (window.MBM_CLIP_SELL || ''),
      room: 'acqRoom', rv: '.acq-rv', hero: '.acq-hero .acq-rv'
    }
  };

  var room, vid, panel, settleT, curKey, avBack;
  var curRoom, roomIO;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function build() {
    room = document.createElement('div');
    room.className = 'av-room';
    room.setAttribute('aria-hidden', 'true');

    vid = document.createElement('video');
    vid.className = 'av-video';
    vid.muted = true; vid.playsInline = true; vid.preload = 'auto';
    vid.setAttribute('muted', ''); vid.setAttribute('playsinline', '');

    panel = document.createElement('div');   // kept for layout parity; unused (both sides lead into a room)
    panel.className = 'av-panel';

    avBack = document.createElement('button');
    avBack.className = 'av-back'; avBack.type = 'button';
    avBack.innerHTML = '&larr; Back to the Vault';
    avBack.addEventListener('click', close);

    room.appendChild(vid);
    room.appendChild(panel);
    room.appendChild(avBack);
    document.body.appendChild(room);
  }

  /* ---- generic room reveal (SELL -> #acqRoom, SHOP -> #showRoom) ---- */
  function revealRoom(r) {
    var el = document.getElementById(r.room);
    if (!el) return;
    curRoom = el;
    el.setAttribute('aria-hidden', 'false');
    el.scrollTop = 0;
    el.classList.add('on');
    /* hide the arrival overlay's back button so it does not show through the
       transparent top of the room (the room has its own back control) */
    if (avBack) avBack.style.display = 'none';
    setupRoomReveal(el, r);
    /* focus the CONTAINER (not a button) so no control shows a stray ring */
    el.setAttribute('tabindex', '-1');
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  function setupRoomReveal(el, r) {
    var items = el.querySelectorAll(r.rv);
    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (x) { x.classList.add('in'); });
      return;
    }
    if (roomIO) roomIO.disconnect();
    roomIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); roomIO.unobserve(e.target); }
      });
    }, { root: el, threshold: 0.16, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (x) { roomIO.observe(x); });
    /* fail-safe: the first screen is visible even if IO is slow */
    setTimeout(function () { el.querySelectorAll(r.hero).forEach(function (x) { x.classList.add('in'); }); }, 220);
  }

  function hideRoom() {
    if (!curRoom) return;
    var el = curRoom;
    el.classList.remove('on');
    el.setAttribute('aria-hidden', 'true');
    if (roomIO) { roomIO.disconnect(); roomIO = null; }
    setTimeout(function () { el.querySelectorAll('.in').forEach(function (x) { x.classList.remove('in'); }); }, 420);
    curRoom = null;
  }

  function open(key, trigger) {
    if (!ROOMS[key]) return;
    if (!room) build();
    if (curRoom) hideRoom();   // switching rooms (e.g. Showroom -> Acquisitions): close the open one first
    /* PHASE 1 telemetry: the Acquisition Room opening is a funnel stage.
       trigger = 'url' (?vault=sell deep link / printed QR) or 'door' (on-page). */
    if (key === 'sell') {
      try { if (window.MBMForms && window.MBMForms.track) window.MBMForms.track('acq_room_open', { trigger: trigger || 'door', page_path: window.location.pathname }); } catch (e) {}
    }
    curKey = key;
    var r = ROOMS[key];
    document.body.classList.add('av-lock');
    panel.classList.remove('show');
    panel.innerHTML = '';

    room.classList.add('on');

    var settle = function () { clearTimeout(settleT); revealRoom(r); };

    if (!r.clip) {
      // No arrival clip hosted yet: rise the room promptly over its own backdrop.
      clearTimeout(settleT);
      settleT = setTimeout(settle, 480);
      return;
    }

    vid.src = r.clip;
    vid.load();
    vid.onended = settle;                       // settle on the clip's final frame (short clips)
    clearTimeout(settleT);
    settleT = setTimeout(settle, 1300);         // snappier: reveal the room within 1.3s even if the clip is slow/blocked
    vid.onloadedmetadata = function () {        // reveal the room PART WAY into the clip (it keeps playing behind the room) so the cards arrive fast
      clearTimeout(settleT);
      settleT = setTimeout(settle, Math.min(vid.duration + 0.5, 1.3) * 1000);
    };
    vid.oncanplay = function () {                // play only once the clip can actually start
      vid.oncanplay = null;
      var p = vid.play();
      if (p && p.catch) p.catch(function () {}); // if autoplay is blocked, the duration timer settles
    };
  }

  function close() {
    hideRoom();
    if (!room) { document.body.classList.remove('av-lock'); return; }
    room.classList.remove('on');
    document.body.classList.remove('av-lock');
    panel.classList.remove('show');
    if (avBack) avBack.style.display = '';   // restore for the next arrival
    clearTimeout(settleT);
    try { vid.pause(); } catch (e) {}
    curKey = null;
    /* drop focus so the just-exited vault button does not keep a gold focus ring */
    try { if (document.activeElement && document.activeElement.blur) document.activeElement.blur(); } catch (e) {}
  }

  /* hero choice clusters (data-vault) — ignore descent ones (descent.js owns those) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-vault]'); if (!a) return;
    if (a.closest('.descent')) return;
    e.preventDefault();
    open(a.getAttribute('data-vault') === 'sell' ? 'sell' : 'shop');
  });

  /* room controls: back-to-vault + in-room smooth scroll (works for either room) */
  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('[data-acq-close]');
    if (closeBtn) { e.preventDefault(); close(); return; }
    var to = e.target.closest('[data-acq-to]');
    if (to) {
      e.preventDefault();
      var t = document.getElementById(to.getAttribute('data-acq-to'));
      if (t) t.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }
  });

  /* Header/footer logo always returns home. The homepage logo is an in-page
     anchor (href="#top"), so inside a room overlay a plain anchor jump just
     scrolls the hidden page underneath and nothing visible happens. Intercept
     anchor-style logos: if a room is open, close it and snap to the top of the
     homepage. (Logos on other pages use href="home-v2.html" and navigate
     natively, so they are left alone.) */
  document.addEventListener('click', function (e) {
    var logo = e.target.closest && e.target.closest('a.logo');
    if (!logo) return;
    var href = logo.getAttribute('href') || '';
    if (href.charAt(0) !== '#') return;            // real navigation link: let it through
    if (document.body.classList.contains('av-lock') ||
        document.querySelector('#acqRoom.on, #showRoom.on')) {
      e.preventDefault();
      close();
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
    /* no room open: fall through to the native #top scroll-to-home */
  });

  /* ESC closes whichever room is open */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && curRoom && curRoom.classList.contains('on')) close();
  });

  /* reveal the two open-vault choice clusters on the hero */
  function showChoices() {
    ['vdoorShop', 'vdoorSell'].forEach(function (id) {
      var el = document.getElementById(id); if (el) el.classList.add('on');
    });
  }
  if (document.readyState !== 'loading') showChoices();
  else document.addEventListener('DOMContentLoaded', showChoices);

  /* Deep link: open a room directly when arriving via ?vault=sell|shop. The Sell
     page funnels here to submit a collection, because the Acquisition Room is the
     only intake path. */
  (function () {
    var m = /[?&]vault=(sell|shop)/.exec(location.search || '');
    if (!m) return;
    var go = function () { open(m[1], 'url'); };
    if (document.readyState !== 'loading') setTimeout(go, 0);
    else document.addEventListener('DOMContentLoaded', go);
  })();

  /* same public API the descent expects */
  window.MBMVault = { enter: open, back: close };
})();
